import { useState, useEffect, useRef } from 'react';
import { ApiService } from '../services/api';
import { PipelineResult } from '../types/models';

interface ApplicationStatus {
  processing_status: string | null;
  pd_result: PipelineResult | null;
}

/**
 * Custom hook для polling статуса заявки
 * 
 * @param appId - ID заявки
 * @param interval - Интервал polling в миллисекундах (по умолчанию 10 сек)
 * @param enabled - Включить/выключить polling
 */
export function useApplicationPolling(
  appId: number | null,
  interval: number = 10000,
  enabled: boolean = true
) {
  const [status, setStatus] = useState<ApplicationStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  
  useEffect(() => {
    if (!appId || !enabled) {
      setLoading(false);
      return;
    }
    
    // Загружаем сразу при монтировании
    loadStatus();
    
    // Запускаем polling
    intervalRef.current = setInterval(loadStatus, interval);
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [appId, interval, enabled]);
  
  async function loadStatus() {
    if (!appId) return;
    
    try {
      const response = await ApiService.getPDResult(appId);
      setStatus({
        processing_status: response.processing_status || null,
        pd_result: response.pd_result
      });
      setLoading(false);
    } catch (err) {
      console.error('Error loading application status:', err);
      setLoading(false);
    }
  }
  
  return { 
    status, 
    loading, 
    refresh: loadStatus 
  };
}
